/* eslint-disable */
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import { XSquare } from "react-bootstrap-icons";
import { logoutUrl, myResultUrl } from "../../utils/constants";
import { useAuth } from "../../components/AuthContext/AuthContext";
import useApis from "../../services/useAPI";
import { Navigate } from "react-router-dom";
import { isSafeUrl } from "../../utils";

const Redirection = () => {
    const [loading, setLoading] = useState(true);
    const [redirectLink, setRedirectLink] = useState(null);
    const auth = useAuth(); 
    const { callApi, resultGet, resultPost, isLoading, serverError } = useApis() || {};
    useEffect(() => {
        const fetchTests = async () => {
            setLoading(true);
            try {
                const response = await axios.get(
                    `${myResultUrl}?latest=true`,
                    {
                        headers: {
                            Authorization: `Bearer ${Cookies.get("access_token")}`,
                        },
                    }
                );

                if (response?.data?.pkb_redirection_url) {
                    setRedirectLink(response.data.pkb_redirection_url);
                }
            } catch (error) {
                if (
                    error?.response?.data?.session_expired ||
                    error?.response?.data?.unauthorized
                ) {
                    callApi(null, logoutUrl, "POST");
                    auth.logout?.();
                    auth.showToast?.(
                        "Error",
                        "You have logged in to another device",
                        "../assets/mhc.png",
                        <XSquare />
                    );
                }
            } finally {
                setLoading(false);
            }
        };

        fetchTests();
    }, []);

    if (loading && !redirectLink) {
        return (
            <div className="text-center">
                <Spinner role="output" animation="border" variant="info" className="my-custom-spinner"/>
            </div>
        );
    }

    if (redirectLink && localStorage.getItem('pkb_status') === 'inactive') {
        if (!isSafeUrl(redirectLink)) {
            auth.showToast('Error', 'Invalid redirect URL');
            return <Navigate to={'/'} />;
        }

        window.location.href = redirectLink;
        return (
            <div className="text-center mt-5">
                <div className="spinner-border text-primary mb-3" role="status" />
                <h5 className="text-muted">Redirecting you to the linking page...</h5>
            </div>
        );
    } else {
        auth.showToast('Error', "You already have a registration with PKB");
        return <Navigate to={'/'} />;
    }
};

export default Redirection;
